import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./LanguageButton.scss");

export type Country =
    | "CS"
    | "DA"
    | "DE"
    | "EL"
    | "EN"
    | "ES"
    | "FR"
    | "NL"
    | "TR"
    | "HR";

export interface LanguageButtonProps {
    readonly country: Country;
    readonly onClick?: () => void;
}

export default function LanguageButton({
    country,
    onClick
}: LanguageButtonProps) {
    return (
        <button className={classnames(style.languageButton)} onClick={onClick}>
            <div className={classnames(style.flag, country.toLowerCase())} />
        </button>
    );
}
